module.exports = __webpack_public_path__ + "static/media/feature.ab7d9284.svg";